import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import ImageGalleryCard from "./ImageGalleryCard";
import { ImageData } from "../../../../Types/ImageSuite-types";

interface ImagesGallerySelectionProps {
  imagesData: ImageData[];
  setImageSourceSelected?: (image: File | string | null) => void;
}

const ImagesGallerySelection = ({
  imagesData,
  setImageSourceSelected,
}: ImagesGallerySelectionProps) => {
  const [selectedImage, setSelectedImage] = useState<string|null>(null);

  useEffect(()=>{
    setImageSourceSelected?.(selectedImage)
  },[selectedImage])

  return (
    <Box
      sx={{
        flexGrow: 1,
        display: "grid",
        placeItems:{xs:"center", md:"start"},
        gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))",
        gridTemplateRows: "repeat(auto-fill, 180px)",
        gap: "16px",
        overflowY: "auto",
        "&::-webkit-scrollbar": {
          display: "none",
        },
      }}
    >
      {imagesData?.map((image,index) => (
        <ImageGalleryCard
          key={index}
          imageUrl={image.imageUrl}
          isSelected={selectedImage === image.imageUrl}
          handleImageCardClick={() => setSelectedImage(image.imageUrl)}
        />
      ))}
    </Box>
  );
};

export default ImagesGallerySelection;
